import { render, staticRenderFns } from "./MissingRecords.vue?vue&type=template&id=36a85597&scoped=true&"
import script from "./MissingRecords.vue?vue&type=script&lang=ts&"
export * from "./MissingRecords.vue?vue&type=script&lang=ts&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./MissingRecords.vue?vue&type=style&index=1&id=36a85597&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a85597",
  null
  
)

export default component.exports